import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 3h-5v5","key":"svg-0"}],["path",{"d":"M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93","key":"svg-1"}]]

const IconArrowBearLeft = createReactComponent('outline', 'arrow-bear-left', 'ArrowBearLeft', __iconNode);

export default IconArrowBearLeft;